/**
 * Copyright (c) 2022 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */

import { CredentialTypeList } from 'blb-components/AuthenticatedApp/RON/NotaryPage/CredentialTable';
export const getLatestCredentialsByType = credentials => {
  const sortedCredential = credentials.sort((credential1, credential2) => credential2.createdAt.getTime() - credential1.createdAt.getTime());
  return CredentialTypeList.map(credentialType => {
    return {
      credential: sortedCredential.find(c => c.type === credentialType),
      credentialType
    };
  });
};